// @flow
import * as React from 'react';
import { Select as SpeedSelect } from 'speed-js-react-web';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import FieldWrapper from 'speed-js-react-web/src/components/grommet2/forms/fields/FieldWrapper';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';
import memoizeOne from 'memoize-one';


/**
 * Select with unique_among functionality. If some of the fields specified in unique_among is set with the same
 * value, the field will be set to null.
 * @param {mixed} value Choice
 * @param {mixed} _original All data from the api
 * @return {void}
 */
class Select extends SpeedSelect {
    getSelectChoices = memoizeOne((choices, values, uniqueAmong) => {
        if (uniqueAmong) {
            const _selectChoices = { ...choices };
            uniqueAmong.forEach((field) => delete _selectChoices[values[field]]);
            return _selectChoices;
        }

        return choices;
    });

    handleChange = (value: string, _original: Object) => {
        const {
            form: { setFieldValue, setFieldTouched, values }, field: { name }, unique_among: uniqueAmong, onChange,
        } = this.props;

        if (uniqueAmong) {
            uniqueAmong.forEach((uniqueName) => {
                if (values[uniqueName] && values[uniqueName].toString() === value) {
                    setFieldValue(uniqueName, null);
                    setFieldTouched(uniqueName, true, true);
                }
            });
        }
        setFieldValue(name, value);
        if (onChange) {
            onChange(value, _original);
        }
    };

    render() {
        const {
            disabled,
            field: {
                name, value,
            },
            many,
            choices,
            label,
            help_text: help,
            required,
            empty_label: emptyLabel,
            resource_name: resourceName,
            value_field: valueField,
            label_fields: labelFields,
            additional_filters: additionalFilters,
            search_field: searchField,
            preload,
            creatable,
            onCreateOption,
            formatOptionLabel,
            form: {
                errors, touched, isSubmitting, values,
            },
            unique_among: uniqueAmong,
        } = this.props;

        const selectChoices = this.getSelectChoices(choices, values, uniqueAmong);

        const defaultEmptyMsg = emptyLabel || (
            <>
                <FormattedMessage
                    id="empty-select-label"
                    defaultMessage="No"
                />
                {
                    ` ${label.toLowerCase()}`
                }
            </>
        );

        return (
            <FieldWrapper
                name={name}
                required={required}
                helpText={help}
                label={label}
            >
                <BaseSelect
                    ref={this.selectRef}
                    name={name}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    value={typeof value === 'undefined' || value === '' ? null : value}
                    id={`id-${name}`}
                    multi={many}
                    choices={selectChoices}
                    emptyLabel={emptyLabel || defaultEmptyMsg}
                    placeholder={emptyLabel || defaultEmptyMsg}
                    resourceName={resourceName}
                    searchField={searchField}
                    valueField={valueField}
                    labelFields={labelFields}
                    additionalFilters={additionalFilters}
                    preload={preload}
                    errors={get(errors, name)}
                    touched={get(touched, name)}
                    disabled={disabled || isSubmitting}
                    creatable={creatable}
                    onCreateOption={onCreateOption}
                    formatOptionLabel={formatOptionLabel}
                    menuPlacement="auto"
                    menuPortalTarget={document.querySelector('#root > div')} // Selects the 'Grommet' div which will
                    // apply the necessary styles to the select menu
                />
            </FieldWrapper>
        );
    }
}

export default Select;
